import { v4 as uuidGen } from 'uuid';
import CookiesProvider from '../providers/Cookies/Cookies';
import { setFunctionalCookie } from './resyUCMCookieUtils';

const getUuid = (uuidFromState) => {
  let uuidListener = () => {};
  let uuid = CookiesProvider.get('uuid');

  if (!uuid) {
    uuid = uuidFromState || uuidGen();
    uuidListener = setFunctionalCookie('uuid', uuid,
      {
        expires: moment().add(1, 'year').toDate(),
        path: '/',
      });
  }

  return [uuid, uuidListener];
};

export default getUuid;
